import { Component, ChangeDetectionStrategy } from '@angular/core';
import { ImportComponent } from '../../../developer/import/import.component';

@Component({
    selector: 'app-transport-import',
    templateUrl: './transport-import.component.html',
    styleUrls: ['./transport-import.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [ImportComponent]
})
export class TransportImportComponent {
}
